import React, { useState } from 'react';
import ImageModal from './ImageModal';

function ShopPictureField({ imageSrc }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  if (!imageSrc) return null;

  return (
    <div>
      <div className="Label_name_details">
        <label>Shop Picture</label>
      </div>
      <div className="input_field handle">
        <img
          alt="img"
          id="zoom"
          height="80 rem"
          style={{ marginLeft: '0.5rem' }}
          onClick={openPopup}
          src={imageSrc}
        />
        <ImageModal
          isOpen={isPopupOpen}
          onClose={closePopup}
          imageSrc={imageSrc}
        />
      </div>
    </div>
  );
}

export default ShopPictureField;
